import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import ReactDOM from 'react-dom';
const Portal = forwardRef((props, ref) => {
    const container = _jsx("div", { ...props, ref: ref });
    return ReactDOM.createPortal(container, document.body);
});
Portal.displayName = 'Portal';
export default Portal;
//# sourceMappingURL=Portal.js.map